( function() {
    let triggerLinks = document.querySelectorAll(".svg-link, .close-program-popup, .opaque-fill");
    let opaqueFill = document.querySelector(".opaque-fill");

    /** 
	 * FUNCTIONS
	 */
	function togglePopup(){
		document.querySelector(".program-popup").classList.toggle( 'popup-active' );
        opaqueFill.classList.toggle('opaque-active');
	}
		
   
	/** 
	 * EVENTS
	 */
    triggerLinks.forEach(item => {
        item.addEventListener("click", function (e) {
            e.preventDefault();
			togglePopup();
		});
     });

} )();